/*
Документация по работе в шаблоне: 
Документация слайдера: https://swiperjs.com/
Сниппет(HTML): swiper
*/

// Подключаем слайдер Swiper из node_modules
// При необходимости подключаем дополнительные модули слайдера, указывая их в {} через запятую
// Пример: { Navigation, Autoplay }
import Swiper, { Navigation, Scrollbar } from "swiper";
/*
Основниые модули слайдера:
Navigation, Pagination, Autoplay, 
EffectFade, Lazy, Manipulation
Подробнее смотри https://swiperjs.com/
*/

// Стили Swiper
// Базовые стили
import "../../../../sass/front/yakuba/base/swiper.scss";
// Полный набор стилей из scss/libs/swiper.scss
// import "../../../scss/yakuba/libs/swiper.scss";
// Полный набор стилей из node_modules
// import 'swiper/swiper-bundle.min.css';

// Инициализация слайдеров
function initSliders() {
    if (document.querySelector(".instagram-swiper")) {
        new Swiper(".instagram-swiper", {
            modules: [Navigation],
            observer: true,
            observeParents: true,
            slidesPerView: "auto",
            spaceBetween: "2.4390243902%",
            centeredSlides: true,
            // autoHeight: true,
            speed: 800,

            //touchRatio: 0,
            //simulateTouch: false,
            // loop: true,
            //preloadImages: false,
            // lazy: true,

            navigation: {
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    centeredSlides: false,
                },
            },
        });
    }
}
// Скролл на базе слайдера (по классу swiper_scroll для оболочки слайдера)
function initSlidersScroll() {
    let sliderScrollItems = document.querySelectorAll(".product-gallery");
    if (sliderScrollItems.length > 0 && window.innerWidth < 991.98) {
        for (let index = 0; index < sliderScrollItems.length; index++) {
            const sliderScrollItem = sliderScrollItems[index];
            const sliderScrollBar =
                sliderScrollItem.querySelector(".swiper-scrollbar");
            if (sliderScrollItem.classList.contains("swiper-autoheight")) {
                const sliderScroll = new Swiper(sliderScrollItem, {
                    modules: [Scrollbar],
                    observer: true,
                    observeParents: true,
                    direction: "horizontal",
                    autoHeight: true,
                    slidesPerView: 1,
                    speed: 500,
                    scrollbar: {
                        el: sliderScrollBar,
                        draggable: true,
                        snapOnRelease: false,
                    },
                    mousewheel: {
                        releaseOnEdges: true,
                    },
                });
                sliderScroll.scrollbar.updateSize();
            } else {
                const sliderScroll = new Swiper(sliderScrollItem, {
                    modules: [Scrollbar],
                    observer: true,
                    observeParents: true,
                    direction: "horizontal",
                    slidesPerView: 1,
                    speed: 500,
                    scrollbar: {
                        el: sliderScrollBar,
                        draggable: true,
                        snapOnRelease: false,
                    },
                    mousewheel: {
                        releaseOnEdges: true,
                    },
                });
                sliderScroll.scrollbar.updateSize();
            }
        }
    }
}

window.addEventListener("load", function (e) {
    // Запуск инициализации слайдеров
    initSliders();
    // Запуск инициализации скролла на базе слайдера (по классу swiper_scroll)
    initSlidersScroll();
});
